export function remoteOptionsWithLoadingPlaceholder<T>(
  base: T[],
  hasLoadedOnce: boolean,
  loading: boolean,
  hasResolvedSelected: boolean,
): T[] | Array<T | undefined> {
  if (
    !hasLoadedOnce &&
    loading &&
    base.length === 0 &&
    !hasResolvedSelected
  ) {
    return [undefined] as Array<T | undefined>
  }
  return base
}
